jQuery(document).ready(function($){
    
    $('.main-nav__toggle').on('click', function(e){
        e.preventDefault();

        $(this).toggleClass('main-nav__toggle--active');
        $('.main-nav__wrapper').toggleClass('main-nav__wrapper--active');
    });

    $('.menu-search-icon').on('click', function(e){
        e.preventDefault();

        $('#search-container').addClass('searchform--visible');
        setTimeout(function(){
            $('#search-container #search-input').get(0).focus();
        }, 150);
    });

    $(document).on('click', function(e){
        const target = $(e.target);

        if ( target.is('.menu-search-icon') || target.closest('.menu-search-icon').length > 0 ) {
            return;
        }

        if ( target.closest('#search-container').length === 0 ) {
            $('#search-container').removeClass('searchform--visible');
        }
    });

    const append_megamenu_to_nav = () => {
        if ( $('.main-nav__megamenu').length === 0 ) {
            return;
        }
        
        const megamenu_html = $('.main-nav__megamenu__dropdown').clone();
        $('.main-nav__megamenu__dropdown').remove();

        $('.main-nav__megamenu').append(megamenu_html);
        megamenu_html.show();
    }

    append_megamenu_to_nav();

});